import PropTypes from "prop-types"
import { createContext } from "react"
import { useMutation, useQuery } from "react-query"
import { createPath, listPaths } from "~/actions/paths"

const LearningPathsContext = createContext()
export default LearningPathsContext

export const PathsContainer = ({ children }) => {
  const createPathMutation = useMutation(createPath)

  const { data: paths, isLoading: pathsLoading } = useQuery("paths", listPaths)
  return (
    <LearningPathsContext.Provider
      value={{ paths, pathsLoading, createPathMutation }}
    >
      {children}
    </LearningPathsContext.Provider>
  )
}

PathsContainer.propTypes = {
  children: PropTypes.node,
}
